import CustomFlowAccessGuard from './CustomFlowAccessGuard';

export const PrivateCustomFlow = CustomFlowAccessGuard;

export default PrivateCustomFlow;
